import { useWageProStore } from './wagepro_store';
import type { UpdateRequest } from './types';

export interface UseUpdateRequestsResult {
  requests: UpdateRequest[];
  open_count: number;
  is_loading: boolean;
  approve: (id: string) => void;
  reject: (id: string) => void;
}

/** Employee-submitted change requests awaiting an HR decision. */
export function useUpdateRequests(): UseUpdateRequestsResult {
  const { update_requests, approve_update_request, reject_update_request } =
    useWageProStore();

  return {
    requests: update_requests,
    open_count: update_requests.filter(
      (request) => request.status === 'in_review',
    ).length,
    is_loading: false,
    approve: approve_update_request,
    reject: reject_update_request,
  };
}
